import { OnboardingReducerFunction, RegisterTourtipAction, ToggleTourTipAction } from '../Onboarding.actions';
import updateImmutable from 'immutability-helper';
import { Tooltip } from '../../constants/content';
import { gqlCompleteStep } from './gotoStep.reducer';

export const tooltipRegisterReducer: OnboardingReducerFunction<RegisterTourtipAction['payload']> = (state, payload) => {
  const { key, status } = payload;
  const { progress } = state;
  const stepIndex = progress.findIndex(
    step =>
      !!step.tooltips.find(
        tooltip => tooltip.id === key && tooltip.registered !== status && (status ? !tooltip.completed : true)
      )
  );
  if (stepIndex > -1) {
    const tourtipIndex = progress[stepIndex].tooltips.findIndex(tip => tip.id === key);
    if (tourtipIndex > -1) {
      return updateImmutable(state, {
        progress: {
          [stepIndex]: {
            $apply: currentStep =>
              updateImmutable(currentStep, {
                tooltips: {
                  $apply: (current: Tooltip[]) =>
                    current.map((tooltip, index) =>
                      updateImmutable(tooltip, {
                        registered: {
                          $apply: currentRegistered => (index === tourtipIndex ? status : currentRegistered)
                        },
                        opened: {
                          $apply: currentlyOpened => (currentlyOpened && status ? false : currentlyOpened)
                        }
                      })
                    )
                }
              })
          }
        }
      });
    }
  }
  return state;
};

export const toggleTourTipReducer: OnboardingReducerFunction<ToggleTourTipAction['payload']> = (state, payload) => {
  const { key, completeStepMutation, userId } = payload;
  const { progress } = state;
  const stepIndex = progress.findIndex(
    step => !!step.tooltips.find(tooltip => tooltip.id === key && tooltip.registered)
  );
  if (stepIndex > -1) {
    const tourtipIndex = progress[stepIndex].tooltips.findIndex(tip => tip.id === key);
    if (tourtipIndex > -1) {
      return updateImmutable(state, {
        progress: {
          [stepIndex]: {
            tooltips: {
              $apply: (current: Tooltip[]) =>
                current.map((tip, index) => {
                  return updateImmutable(tip, {
                    opened: {
                      $apply: currentOpen => {
                        if (index === tourtipIndex) {
                          return !currentOpen;
                        } else {
                          if (currentOpen) {
                            // we use this set timeout with 0 to make sure we complete the current step
                            // only once we have completed rerender due to changes in provider
                            setTimeout(() => {
                              gqlCompleteStep(completeStepMutation, tip.id, userId);
                            }, 0);
                          }
                          return false;
                        }
                      }
                    }
                  });
                })
            }
          }
        }
      });
    }
  }
  return state;
};
